import {
  StyledLogout,
  StyledLogoutContent,
  StyledLogoutIcon,
  StyledLogoutText,
} from './Logout.style';
import Separator from '../Separator';
import LogoutIcon from '../../../../images/icons/logout.svg';

const Logout = ({ onLogoutClick }) => {
  return (
    <StyledLogout onClick={onLogoutClick}>
      <Separator />
      <StyledLogoutContent>
        <StyledLogoutIcon>
          <LogoutIcon />
        </StyledLogoutIcon>
        <StyledLogoutText>Log out</StyledLogoutText>
      </StyledLogoutContent>
    </StyledLogout>
  );
};

export default Logout;
